import { default as React, Fragment } from 'react';
import { CategoriesFilter } from './categories/Filter';
import { CategoriesType } from './categories/Type';
export const Categories = (props) => <Fragment>
      <CategoriesType sportID={props.sportID} statTypesData={props.statTypesData} onStatTypeSelect={props.onStatTypeSelect} toLocale={props.toLocale}/>
      <CategoriesFilter categoriesData={props.categoriesData} onFoldAllTables={props.onFoldAllTables} isAllUnfolded={props.isAllUnfolded} onFavorite={props.onFavorite} onSelect={props.onSelect} toLocale={props.toLocale} sportID={props.sportID} matchID={props.matchID} width={props.width}/>
   </Fragment>;



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/Сategories.jsx